var _path, _ellipse, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2121 13.5303V12.3788C11.2121 11.1069 10.181 10.0758 8.90909 10.0758H4.30303C3.0311 10.0758 2 11.1069 2 12.3788V13.5303",
    stroke: "#1E1E1E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.60576,
    cy: 5.4697,
    rx: 2.30303,
    ry: 2.30303,
    stroke: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 13.5303V12.3788C14.6659 11.3292 13.9557 10.413 12.9395 10.1506",
    stroke: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6367 3.24152C11.6558 3.50243 12.3685 4.42066 12.3685 5.47258C12.3685 6.52449 11.6558 7.44272 10.6367 7.70364",
    stroke: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c601095f97243546242930c5bb18f70c.svg";
export { ForwardRef as ReactComponent };